<template>
  <b-modal
    id="modal-conflict"
    size="lg"
    title="Konflik Voice Announcer"
    centered
    data-me="rjm-component-modal-conflict"
  >
    <p v-if="triggerType === 'enter'">
      {{ $t('rjm.conflictEnter') }}
    </p>
    <p v-else>
      {{ $t('rjm.conflictExit') }}
    </p>

    <div class="my-3">
      <McGrapqlTable
        :apiClient="query"
        :fields="fields"
        :hasCheckbox="false"
        :showPagination="true"
        :busy="isLoading"
        :isEmpty="items.length === 0"
        data-me="rjm-component-modal-conflict-table"
      >
        <template #cell(assignmentValue)="{ item }">
          {{
            item.assignmentValue === 'enter'
              ? $t('rjm.enter')
              : item.assignmentValue === 'exit'
              ? $t('rjm.exit')
              : item.assignmentValue
          }}
          {{ $t('rjm.location') }}
        </template>
      </McGrapqlTable>
    </div>

    <p>{{ $t('rjm.continueSaveWithoutVehicle') }}</p>

    <template #modal-footer="{ cancel }">
      <b-row class="mc-modal__filter-footer mx-0 w-100">
        <b-col sm="12" md="12" class="mc-modal__filter-footer-btn mt-0 d-flex justify-content-end">
          <McButton
            variant="outline-primary"
            class="me-2"
            :text="$t('global.action.cancel')"
            @click="cancel()"
            data-me="rjm-component-modal-conflict-button-cancel"
          />
          <McButton
            variant="primary"
            :text="$t('global.action.save')"
            :disabled="isLoading"
            @click="handleSave()"
            data-me="rjm-component-modal-conflict-button-save"
          />
        </b-col>
      </b-row>
    </template>
  </b-modal>
</template>

<script>
import McButton from '@/components/McButton'
import { Helper } from '@/mixin/helper'
import { createAudioAssignment, updateAudioAssignment } from '@/services/api/master/rjm'
import McGrapqlTable from '@/components/McGrapqlTable'

export default {
  name: 'ModalConflict',

  components: { McButton, McGrapqlTable },
  mixins: [Helper],
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    input: {
      type: Object,
      default: () => ({}),
    },
    triggerType: {
      type: String,
      default: 'enter',
    },
  },
  data() {
    return {
      isLoading: false,
      fields: [
        {
          key: 'label',
          label: this.$t('rjm.nameAlert'),
          shown: true,
        },
        {
          key: 'audioFile.label',
          label: 'Audio',
          shown: true,
        },
        {
          key: 'assignmentValue',
          label: this.$t('rjm.condition'),
          shown: true,
          formatter: (val) => (val ? val.toUpperCase() : '-'),
        },
        {
          key: 'geofence.fenceName',
          label: this.$t('rjm.location'),
          shown: true,
        },
        {
          key: 'vehicle.licensePlate',
          label: this.$t('rjm.vehicle'),
          shown: true,
        },
      ],
    }
  },
  computed: {
    query() {
      return {
        get: async () => {
          return {
            data: this.items,
            pagination: {
              total: this.items.length,
              page: 1,
              show: this.items.length,
            },
          }
        },
      }
    },
  },
  methods: {
    async handleSave() {
      this.isLoading = true
      try {
        const isUpdate = !!this.input.audioAssignmentId
        const submitInput = { ...this.input }
        if (isUpdate) {
          delete submitInput.assignmentType
        }

        const res = await this.$apollo.mutate({
          mutation: isUpdate ? updateAudioAssignment : createAudioAssignment,
          variables: {
            input: submitInput,
          },
        })

        const mutationName = isUpdate ? 'updateAudioAssignment' : 'createAudioAssignment'
        if (res.data[mutationName].isSuccessful) {
          this.$mcToast.success(res.data[mutationName].message)
          this.$bvModal.hide('modal-conflict')
          this.$router.push('/master/rjm')
        } else {
          this.$bvModal.hide('modal-conflict')
          this.$mcToast.error(res.data[mutationName].message)
        }
      } catch (error) {
        this.$bvModal.hide('modal-conflict')
        this.$mcToast.error(error.message)
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>
